import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import { SelectionBar } from 'components/UI/V3/SelectionBar';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { RateRulesList } from './RateRulesList/RateRulesList';
import RateRulesIsEmpty from './RateRulesIsEmpty';
import { useBoardingRateRules } from '../BoardingRateRulesProvider';
import styles from './RateRulesContent.module.scss';

const RateRulesContent: FunctionComponent = () => {
    const isMobile = useMediaQuery({ query: '(max-width:768px)' });
    const { rateRules, selectedFilter, filterChangeHandler, openAddForm, isFilteredEmpty } = useBoardingRateRules();

    return (
        <div className={styles.root}>
            <div className={styles.headWrapper}>
                <DefaultHeader
                    title={
                        <SelectionBar
                            options={[
                                { id: 'active', name: 'Active' },
                                { id: 'inactive', name: 'Inactive' }
                            ]}
                            selectedId={selectedFilter}
                            onSelect={filterChangeHandler}
                            className={styles.selectionBar}
                        />
                    }
                    buttonLabel={isMobile ? 'Add' : 'Add Rate Rule'}
                    displayButton={true}
                    onClick={openAddForm}
                    buttonIcon={faPlus}
                    className={styles.header}
                />
            </div>

            <div className={styles.contentContainer}>
                {isFilteredEmpty ? (
                    <RateRulesIsEmpty
                        title="No rate rules found"
                        text="No Rate Rules match your filter selection. Try changing or clearing the filter to see more."
                        showButton={false}
                    />
                ) : (
                    <RateRulesList rateRules={rateRules} />
                )}
            </div>
        </div>
    );
};

export default RateRulesContent;
